import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';


const getFromDate = (roster, timeMode) =>
    timeMode === 'UTC'
        ? new Date(roster.fullAtd || roster.fullStd)
        : new Date(roster.fullAtdBase || roster.fullStdBase);

const getToDate = (roster, timeMode) =>
    timeMode === 'UTC'
        ? new Date(roster.fullAta || roster.fullSta)
        : new Date(roster.fullAtaBase || roster.fullStaBase);


export const processData = (rosterDetails, timeMode) => {
    const tasks = [];
    const links = [];

    // Group by crew key, sorted
    const rostersByCrew = new Map();
    rosterDetails.forEach(roster => {
        const key = roster.post + roster.base + String(roster.crewCode).padStart(6, '0') || 'Unknown';
        if (!rostersByCrew.has(key)) rostersByCrew.set(key, []);
        rostersByCrew.get(key).push(roster);
    });

    const sortedKeys = [...rostersByCrew.keys()].sort();

    for (const key of sortedKeys) {
        const rosters = rostersByCrew.get(key);
        const crewCode = rosters[0]?.crewCode || 'N/A';
        const crewName = rosters[0]?.crewName || 'Unknown';
        const post = rosters[0]?.post || 'N/A';
        const base = rosters[0]?.base || 'N/A';

        const parentId = `parent_${crewCode}`;
        tasks.push({
            id: parentId,
            text: `${crewCode} - ${crewName} (${post}|${base})`,
            isParent: true,
            crewCode,
            crewName,
        });

        for (let index = 0; index < rosters.length; index++) {
            const roster = rosters[index];
            const fromDate = getFromDate(roster, timeMode);
            const toDate = getToDate(roster, timeMode);

            if (isNaN(fromDate) || isNaN(toDate)) continue;

            tasks.push({
                id: roster._id,
                text: `
                    <div class="crew-multi-line-text">
                        ${roster.routeNo ? roster.dep : '&nbsp;'}<br/>
                        ${roster.flightNo}<br/>
                        ${roster.routeNo ? roster.arr : '&nbsp;'}
                    </div>
                `,
                start_date: format(toZonedTime(fromDate, 'UTC'), 'dd-MM-yyyy HH:mm'),
                duration: Math.max(0, Math.round((toDate - fromDate) / 3600000)),
                progress: roster.progress || 0,
                parent: parentId,
                crewCode,
                crewName: roster.crewName,
                flightDate: roster.flightDate,
                flightCarrier: roster.flightCarrier,
                flightNo: roster.flightNo,
                flightDesc: `${roster.flightCarrier}${roster.flightNo}`,
                dep: roster.dep,
                arr: roster.arr,
                std: roster.std,
                sta: roster.sta,
                atd: roster.atd,
                ata: roster.ata,
                blockHours: roster.blockHours,
                sectorType: roster.sectorType || "Unknown",
            });

            if (index > 0) {
                const prev = rosters[index - 1];
                links.push({
                    id: `link_${prev._id}_${roster._id}`,
                    source: prev._id,
                    target: roster._id,
                    type: "0",
                });
            }
        }
    }

    return { tasks, links };
};
